module.exports = __webpack_public_path__ + "static/media/1009906.3e984ee8.jpg";